module.exports = __webpack_public_path__ + "static/media/google-play-nl.97dd39cc.svg";